<template>
    <div class="filters-container weeduc-admin-page__toolbar">
        <div class="filters-content">
            <!-- Filtro de Nome do Curso -->
            <div class="filter-group" v-if="showCourseFilter">
                <div class="filter-input-wrapper">
                    <fa icon="fa-solid fa-graduation-cap" class="filter-icon" />
                    <input 
                        type="text" 
                        v-model="filters.courseName" 
                        class="filter-input"
                        :placeholder="$t('admin.reports.filters.course')"
                        @input="applyFilters"
                    />
                </div>
            </div>

            <!-- Filtro de Nome do Cliente/Usuário -->
            <div class="filter-group" v-if="showUserFilter">
                <div class="filter-input-wrapper">
                    <fa icon="fa-solid fa-user" class="filter-icon" />
                    <input 
                        type="text" 
                        v-model="filters.userName" 
                        class="filter-input"
                        :placeholder="$t('admin.reports.filters.userName')"
                        @input="applyFilters"
                    />
                </div>
            </div>

            <!-- Filtro de Email -->
            <div class="filter-group" v-if="showEmailFilter">
                <div class="filter-input-wrapper">
                    <fa icon="fa-solid fa-envelope" class="filter-icon" />
                    <input 
                        type="text" 
                        v-model="filters.userEmail" 
                        class="filter-input"
                        :placeholder="$t('admin.reports.filters.email')"
                        @input="applyFilters"
                    />
                </div>
            </div>

            <!-- Filtro de CPF -->
            <div class="filter-group" v-if="showCpfFilter">
                <div class="filter-input-wrapper">
                    <fa icon="fa-solid fa-id-card" class="filter-icon" />
                    <input 
                        type="text" 
                        v-model="filters.userCpf" 
                        class="filter-input"
                        :placeholder="$t('admin.reports.filters.cpf')"
                        @input="applyFilters"
                    />
                </div>
            </div>

            <!-- Filtro de Status -->
            <div class="filter-group" v-if="showStatusFilter">
                <div class="filter-input-wrapper">
                    <fa icon="fa-solid fa-toggle-on" class="filter-icon" />
                    <select 
                        v-model="filters.status" 
                        class="filter-input"
                        @change="applyFilters"
                    >
                        <option value="">{{ $t('admin.reports.filters.allStatuses') }}</option>
                        <option value="1">{{ $t('admin.reports.filters.statusOpen') }}</option>
                        <option value="0">{{ $t('admin.reports.filters.statusClosed') }}</option>
                    </select>
                </div>
            </div>

            <!-- Filtro de Nota -->
            <div class="filter-group" v-if="showScoreFilter">
                <div class="filter-input-wrapper">
                    <fa icon="fa-solid fa-star" class="filter-icon" />
                    <select 
                        v-model="filters.score" 
                        class="filter-input"
                        @change="applyFilters"
                    >
                        <option value="">{{ $t('admin.reports.filters.allScores') }}</option>
                        <option value="0-2">{{ $t('admin.reports.filters.score02') }}</option>
                        <option value="2.5-4">{{ $t('admin.reports.filters.score25') }}</option>
                        <option value="4.5-6">{{ $t('admin.reports.filters.score45') }}</option>
                        <option value="6.5-8">{{ $t('admin.reports.filters.score65') }}</option>
                        <option value="8.5-10">{{ $t('admin.reports.filters.score85') }}</option>
                        <option value="aprovado">{{ $t('admin.reports.filters.approvedScore') }}</option>
                        <option value="reprovado">{{ $t('admin.reports.filters.failedScore') }}</option>
                    </select>
                </div>
            </div>

            <!-- Filtro de Data -->
            <div class="filter-group" v-if="showDateFilter">
                <div class="filter-input-wrapper">
                    <fa icon="fa-solid fa-calendar" class="filter-icon" />
                    <input 
                        type="date" 
                        v-model="filters.dateFrom" 
                        class="filter-input"
                        @change="applyFilters"
                    />
                </div>
            </div>

            <!-- Botão Limpar -->
            <div class="filter-actions" v-if="hasActiveFilters">
                <button class="clear-btn" @click="clearFilters" :title="$t('admin.reports.filters.clearAllTitle')">
                    <fa icon="fa-solid fa-times" />
                    <span>{{ $t('common.clear') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AdvancedFilters',
    props: {
        showDateFilter: {
            type: Boolean,
            default: true
        },
        showCourseFilter: {
            type: Boolean,
            default: true
        },
        showUserFilter: {
            type: Boolean,
            default: true
        },
        showEmailFilter: {
            type: Boolean,
            default: false
        },
        showCpfFilter: {
            type: Boolean,
            default: false
        },
        showStatusFilter: {
            type: Boolean,
            default: false
        },
        showScoreFilter: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            filters: {
                dateFrom: '',
                courseName: '',
                userName: '',
                userEmail: '',
                userCpf: '',
                status: '',
                score: ''
            }
        }
    },
    computed: {
        hasActiveFilters() {
            return this.filters.dateFrom || this.filters.courseName || this.filters.userName || this.filters.userEmail || this.filters.userCpf || this.filters.status || this.filters.score;
        }
    },
    methods: {
        clearFilters() {
            this.filters = {
                dateFrom: '',
                courseName: '',
                userName: '',
                userEmail: '',
                userCpf: '',
                status: '',
                score: ''
            };
            this.$emit('filters-cleared');
        },
        applyFilters() {
            const activeFilters = {};
            
            // Filtros de data
            if (this.filters.dateFrom) {
                activeFilters.dateFrom = this.filters.dateFrom;
            }
            
            // Filtros de texto
            if (this.filters.courseName) {
                activeFilters.courseName = this.filters.courseName;
            }
            if (this.filters.userName) {
                activeFilters.userName = this.filters.userName;
            }
            if (this.filters.userEmail) {
                activeFilters.userEmail = this.filters.userEmail;
            }
            if (this.filters.userCpf) {
                activeFilters.userCpf = this.filters.userCpf;
            }
            if (this.filters.status) {
                activeFilters.status = this.filters.status;
            }
            if (this.filters.score) {
                activeFilters.score = this.filters.score;
            }
            
            this.$emit('filters-applied', activeFilters);
        }
    }
}
</script>

<style scoped>
.filters-container {
    /* Visual base: .weeduc-admin-page__toolbar (dashboard-weflix-shell.css) */
    padding: 1rem 1.1rem 1.05rem;
    margin-bottom: 1rem;
    border-radius: 12px;
}

.filters-content {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    flex-wrap: wrap;
}

.filter-group {
    flex: 1;
    min-width: 200px;
}

.filter-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.filter-icon {
    position: absolute;
    left: 12px;
    color: #64748b;
    font-size: 14px;
    z-index: 2;
    pointer-events: none;
}

.filter-input {
    width: 100%;
    padding: 10px 12px 10px 38px;
    border: 1px solid #e0e2e8;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    background: #fff;
    color: #334155;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.filter-input:focus {
    outline: none;
    border-color: #250891;
    box-shadow: 0 0 0 3px rgba(37, 8, 145, 0.12);
}

.filter-input::placeholder {
    color: #94a3b8;
    font-weight: 400;
}

.filter-input select {
    background: transparent;
    border: none;
    outline: none;
    width: 100%;
    font-size: 14px;
    font-weight: 500;
    color: #334155;
    cursor: pointer;
}

.filter-input select option {
    background: white;
    color: #334155;
    padding: 8px;
}

.filter-actions {
    display: flex;
    align-items: center;
    margin-left: auto;
}

.clear-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);
}

.clear-btn:hover {
    background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(239, 68, 68, 0.4);
}

.clear-btn:active {
    transform: translateY(0);
}

/* Dark — toolbar vem do shell; campos locais */
.dashboard.dark .filter-icon {
    color: #9ca3af;
}

.dashboard.dark .filter-input {
    background: #323643;
    border-color: #454a5a;
    color: #f1f3f7;
}

.dashboard.dark .filter-input:focus {
    border-color: #7c6fd6;
    box-shadow: 0 0 0 3px rgba(124, 111, 214, 0.2);
}

.dashboard.dark .filter-input::placeholder {
    color: #6b7280;
}

/* Responsive */
@media (max-width: 768px) {
    .filters-content {
        flex-direction: column;
        gap: 1rem;
    }
    
    .filter-group {
        min-width: 100%;
    }
    
    .filter-actions {
        margin-left: 0;
        width: 100%;
        justify-content: center;
    }
    
    .clear-btn {
        width: 100%;
        justify-content: center;
    }
}

@media (max-width: 480px) {
    .filters-container {
        padding: 1rem;
    }
    
    .filter-input {
        padding: 10px 10px 10px 36px;
        font-size: 13px;
    }
    
    .filter-icon {
        left: 10px;
        font-size: 13px;
    }
}
</style>
